import { render, staticRenderFns } from "./subtypes.vue?vue&type=template&id=7e2ff9f0&"
import script from "./subtypes.vue?vue&type=script&lang=js&"
export * from "./subtypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports